var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yimo-vue-editor",attrs:{"id":_vm.editorId}})
}
var staticRenderFns = []

export { render, staticRenderFns }